import { SubtitlesDevice, SubtitlesTextSize } from '../../components/subtitles/types';

import { BitMask } from './BitMask';

export enum SubtitlesBitMaskTypes {
  /**
   * 4 right most bits are used
   * first 2 right most bits indicate desktop subtitles sizes from 1-3
   * first 2 bits with right offset 2 indicate mobile subtitles sizes from 1-3
   * numeric map of subtitle sizes:
   * - 01: 1 in decimal is small
   * - 10: 2 in decimal is medium
   * - 11: 3 in decimal is large
   */
  DesktopSubtitlesSmall = 0b00000001,
  DesktopSubtitlesMedium = 0b00000010,
  DesktopSubtitlesLarge = 0b00000011,
  MobileSubtitlesSmall = 0b00000100,
  MobileSubtitlesMedium = 0b00001000,
  MobileSubtitlesLarge = 0b00001100,
}

class SubtitlesBitMaskBase extends BitMask<SubtitlesBitMaskTypes> {
  public resetSize(deviceType: SubtitlesDevice): void {
    switch (deviceType) {
      case SubtitlesDevice.DESKTOP:
        this.partialReset(SubtitlesBitMaskTypes.DesktopSubtitlesLarge);
        break;
      case SubtitlesDevice.MOBILE:
        this.partialReset(SubtitlesBitMaskTypes.MobileSubtitlesLarge);
        break;
      default:
        this.reset();
    }
  }

  public applySizeMask = (deviceType: SubtitlesDevice, sizes: SubtitlesTextSize): void => {
    const size = this.getSizeBitMask(deviceType, sizes);
    if (size) this.apply(size);
  };

  private getSizeBitMask(deviceType: SubtitlesDevice, sizes: SubtitlesTextSize): SubtitlesBitMaskTypes | null {
    if (deviceType === SubtitlesDevice.DESKTOP) {
      switch (sizes) {
        case SubtitlesTextSize.SMALL:
          return SubtitlesBitMaskTypes.DesktopSubtitlesSmall;
        case SubtitlesTextSize.MEDIUM:
          return SubtitlesBitMaskTypes.DesktopSubtitlesMedium;
        case SubtitlesTextSize.LARGE:
          return SubtitlesBitMaskTypes.DesktopSubtitlesLarge;
      }
    } else if (deviceType === SubtitlesDevice.MOBILE) {
      switch (sizes) {
        case SubtitlesTextSize.SMALL:
          return SubtitlesBitMaskTypes.MobileSubtitlesSmall;
        case SubtitlesTextSize.MEDIUM:
          return SubtitlesBitMaskTypes.MobileSubtitlesMedium;
        case SubtitlesTextSize.LARGE:
          return SubtitlesBitMaskTypes.MobileSubtitlesLarge;
      }
    }

    return null;
  }
}

export const SubtitlesBitMask = new SubtitlesBitMaskBase();
